/**
 * @description
 * Store any data procesing for store here, to avoid bloating other module files
 * @param {*} someParam
 */
function validateData(clientData, activeTransaction) {
    if(activeTransaction.name == 'quotation'){
        if(clientData.personName && clientData.phone && clientData.email) return 'quotation'
    }
    if(activeTransaction.name == 'invoice'){
        if(clientData.personName && clientData.businessName && clientData.coreBusiness && clientData.address && clientData.email) return 'invoice'
    }
    return null
}

export default { validateData }
